"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TColorVariants = void 0;
var TColorVariants;
(function (TColorVariants) {
    TColorVariants["Primary"] = "primary";
    TColorVariants["Secondary"] = "secondary";
    TColorVariants["Active"] = "active";
    TColorVariants["Success"] = "success";
    TColorVariants["Warning"] = "warning";
    TColorVariants["Danger"] = "danger";
    TColorVariants["Error"] = "error";
    TColorVariants["Info"] = "info";
    TColorVariants["Disabled"] = "disabled";
    TColorVariants["None"] = "";
})(TColorVariants = exports.TColorVariants || (exports.TColorVariants = {}));
//# sourceMappingURL=colors.js.map